import { Link } from "react-router-dom";
import type { Title } from "@/types/media";
import { CATEGORY_META } from "@/lib/media";

interface RankingListProps {
  items: Title[];
}

const RANK_STYLES = [
  "bg-primary-500 text-background-50",
  "bg-accent-500 text-background-950",
  "bg-secondary-500 text-background-50",
];

export default function RankingList({ items }: RankingListProps) {
  return (
    <div className="rounded-lg bg-background-900 border border-background-800 overflow-hidden">
      {items.map((item, i) => (
        <Link
          key={item.id}
          to={`/detail/${item.id}`}
          className="group flex items-center gap-3 md:gap-4 px-4 py-3 border-b border-background-800/70 last:border-b-0 hover:bg-background-800/60 transition-colors"
        >
          <span
            className={`shrink-0 w-7 h-7 rounded-md flex items-center justify-center text-sm font-heading font-bold ${
              RANK_STYLES[i] ?? "bg-background-800 text-foreground-300"
            }`}
          >
            {i + 1}
          </span>
          <div className="w-11 md:w-12 rounded-md overflow-hidden bg-background-800 shrink-0 aspect-[2/3]">
            <img
              src={item.cover}
              alt={`${item.title} 封面`}
              title={`${item.title} 高清在线观看`}
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="min-w-0 flex-1">
            <h3 className="text-sm font-medium text-foreground-100 truncate group-hover:text-primary-400 transition-colors">
              {item.title}
            </h3>
            <p className="text-xs text-foreground-400 mt-1 truncate">
              {CATEGORY_META[item.type].label} · {item.year} · {item.genres[0]}
            </p>
          </div>
          <div className="shrink-0 text-right">
            <p className="text-sm font-semibold text-accent-400 flex items-center gap-1 justify-end">
              <i className="ri-fire-fill"></i>
              {item.views}
            </p>
            <p className="text-xs text-foreground-500 mt-1">评分 {item.rating.toFixed(1)}</p>
          </div>
        </Link>
      ))}
    </div>
  );
}